import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_rabbit_mq_pushService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { egress_id?: string, transaction_id?: string, integration_id?: string, connection?: string, exchange?: string, contract?: string, message?: { Payload?: string, TransactionSet?: string, InboundTransactionId?: string, OutboundTransactionId?: string, Content?: string } }): Promise<{ messages?: any[], success?: boolean }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

